import {EmptySerialGenres} from "./EmptySerialGenre";
import {useGenres} from "../../hooks/UseGenres";
import {useEffect} from "react";
import {useSerialGenres} from "../../hooks/UseSerialGenres";
import {EditSerialGenre} from "./EditSerialGenre";

export function EditSerialGenres(props) {
    const user = props.user;
    const serialId = props.serialId;
    const genresHook = useGenres();
    const serialGenresHook = useSerialGenres();

    useEffect(() => {
        genresHook.loadGenres(user.token);
    }, [user]);

    useEffect(() => {
        if (serialId)
            serialGenresHook.loadSerialGenres(user.token, serialId);
    }, [user, serialId]);

    const onSaveClicked = async (genre) => {
        await serialGenresHook.createGenre(user.token, serialId, genre.genreId);
    };

    const onDeleteClicked = async (serialGenre) => {
        await serialGenresHook.deleteGenre(user.token, serialId, serialGenre.genreId);
    }

    const allGenres = genresHook.genres || [];
    const currentSerialGenres = serialGenresHook.serialGenres || [];

    if (genresHook.loading || serialGenresHook.loading) {
        return <div style={{ textAlign: 'center', padding: '10px', color: '#6b7280' }}>Завантаження...</div>;
    }

    const availableGenres = allGenres.filter(genre =>
        !currentSerialGenres.some(sg => sg.genreId === genre.id)
    );

    const serialGenreElements = currentSerialGenres.map(sg => (
        <EditSerialGenre
            serialGenre={sg}
            key={sg.id || sg.genreId || Math.random()}
            onDeleteClicked={onDeleteClicked}
        />
    ));

    return (
        <div style={{ width: '100%' }}>
            {/* Adding */}
            <div style={{ marginBottom: '15px' }}>
                <EmptySerialGenres
                    genres={availableGenres}
                    onSaveClicked={onSaveClicked}
                />
            </div>

            {/* Tags */}
            <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '4px',
                minHeight: '40px',
                padding: '10px',
                backgroundColor: '#f9fafb',
                borderRadius: '8px',
                border: '1px solid #f3f4f6'
            }}>
                {serialGenreElements.length > 0 ? (
                    serialGenreElements
                ) : (
                    <span style={{ color: '#9ca3af', fontSize: '13px' }}>Жанри не вибрано</span>
                )}
            </div>
        </div>
    );
}
